import { error } from './logger';
export var runProcessors = function (fns) {
    return function (e) {
        var r = e;
        for (var i = 0; i < fns.length; i++) {
            if (r) {
                try {
                    r = fns[i](r);
                }
                catch (err) {
                    error(err);
                }
            }
            else {
                break;
            }
        }
        return r;
    };
};
export var runFilters = function (fns) {
    return function (e) {
        var r = true;
        for (var i = 0; i < fns.length; i++) {
            if (r) {
                try {
                    r = fns[i](e);
                }
                catch (err) {
                    error(err);
                }
            }
            else {
                break;
            }
        }
        return r;
    };
};
//# sourceMappingURL=processor.js.map